<template>
    <div class="ml-2 mr-2">
        <input :id="question.label" v-model="value" type="checkbox" />
    </div>
</template>

<script>
export default {
    props: {
        question: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            value: false
        };
    },

    watch: {
        value: {
            handler(value) {
                this.$emit('input', value);
            },
            immediate: true
        }
    },

    created() {
        this.value = this.question.answer;
    }
};
</script>
